module.exports = __webpack_public_path__ + "img/image29.408ea244.jpg";